import {Capacitor} from '@capacitor/core';
import {Directory, Filesystem} from '@capacitor/filesystem';

export default {
    getFilesByEntity(fileable, fileableId) {
        return new Promise((resolve, reject) => {
            http.get(`api/files?fileable_type=${fileable}&fileable_id=${fileableId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getFilesListByEntity(fileable, fileableId) {
        return new Promise((resolve, reject) => {
            const params = {
                filter: {
                    model_type: fileable,
                    model_id: fileableId
                },
            }
            http.get('api/files/list', {params}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getContent(uuid) {
        return new Promise((resolve, reject) => {
            http.get(`api/files/${uuid}/get-content?extend`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getMediaContent(id) {
        return new Promise((resolve, reject) => {
            http.get(`api/files/media/${id}/get-content?extend`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteFile(fileId) {
        return new Promise((resolve, reject) => {
            http.delete(`api/files/${fileId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getMimeType(extension) {
        const mimeTypes = {
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            png: "image/png",
            gif: "image/gif",
            pdf: "application/pdf",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            txt: "text/plain",
            csv: "text/csv",
            // Add more types as needed
        };
        return mimeTypes[extension.toLowerCase()] || "application/octet-stream"; // Default to binary
    },

    base64ToArrayBuffer(base64) {
        const clean = base64.split(',')[1] || base64;
        const binary = atob(clean);

        const len = binary.length;

        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        return bytes.buffer;
    },

    // use this method, when we do not have base64 yet, we fetch it first
    async downloadFileWithoutBase64(file) {
        let base64Data = (await this.getMediaContent(file.id))?.content;
        await this.downloadFileByPlatform(base64Data, file.name, file.extension);
    },

    async downloadFileByPlatform(fileBase64, fileName, extension) {
        if (Capacitor.isNativePlatform()) {
            let permissionGranted = false;

            // ios doesn't need permission
            if (Capacitor.getPlatform() === 'ios') {
                permissionGranted = true;
            }

            // android needs permission check
            if (Capacitor.getPlatform() === 'android') {
                permissionGranted = (await Filesystem.requestPermissions()).publicStorage === 'granted';
            }

            if (permissionGranted) {
                if (Capacitor.isPluginAvailable('Filesystem')) {
                    await Filesystem.writeFile({
                        path: fileName + '.' + extension,
                        data: fileBase64,
                        directory: Capacitor.getPlatform() === 'ios' ? Directory.External : Directory.Documents,
                    });
                }
            }
        } else {
            const blob = new Blob([this.base64ToArrayBuffer(fileBase64)], {type: this.getMimeType(extension)});
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            a.remove();

            URL.revokeObjectURL(url);
        }
    },

    saveAnnotations(documentTemplateID, annotations, config) {
        return new Promise((resolve, reject) => {
            http.post(`api/document-templates/${documentTemplateID}/pdf-overlay`, {fields: annotations, config}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    }
}
